// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"929c242f","6":"7ac376e0","276":"f269e0fe","613":"929c242f"}[chunkId] + ".chunk.css";
};